import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import axios from "../../helpers/axios";
import {
  Layout,
  Notification,
  ScreenHeading,
} from "../../webtracking/components";

import { SosEtaFrom } from "../components";

const useSosEtaCreate = () => {
  const history = useHistory();

  const [message, setMessage] = useState("");

  const handleSubmit = (values, { setSubmitting }) => {
    axios
      .post(`/api/delivery_time/`, values)
      .then(() => history.goBack())
      .catch((error) => {
        console.error(error);

        if (error.response && error.response.data.non_field_errors) {
          setMessage("Ya existe un tipo de envío idéntico (SOS, TIPO)");
        } else {
          setMessage("No se pudo crear el tipo de envío");
        }
      })
      .then(() => setSubmitting(false));
  };

  return {
    message,
    handleSubmit,
    history,
  };
};

const SosEtaCreate = () => {
  const { message, handleSubmit, history } = useSosEtaCreate();

  return (
    <Layout>
      <ScreenHeading title="Crear ETA" />
      <div className="container has-background-light p-6 mt-5">
        <Notification message={message} />
        <SosEtaFrom
          initial={{
            sos: "",
            shipping_type: "",
            description: "",
            estimated_days: 1,
          }}
          onSubmit={handleSubmit}
          onCancel={() => history.goBack()}
        />
      </div>
    </Layout>
  );
};

export default SosEtaCreate;
